import { Spinner } from '@mgh-app/component-library';
import { RoomButton } from 'components/RoomButton';
import { MainLayoutContext } from 'layouts/MainLayout';
import { Thing, ThingIdentifier, ThingType } from 'models/Thing';
import { useAppNavigation } from 'navigation/useAppNavigation';
import { useContext, useEffect } from 'react';
import { useParams } from 'react-router';
import { selectRoomById } from 'services/RoomService';
import { useGetThingsListQuery } from 'services/ThingsService';
import { useAppSelector } from 'store';
import {
  display,
  gap,
  gridAutoFlow,
  gridAutoRows,
  gridTemplateColumns,
  justifyContent,
  margin,
  overflow,
  tailwindClassNameConvertNegative,
  twCls,
} from 'style';

export const Room = () => {
  const { setTitle, showNavigationButtons, navigateBackAction } = useContext(MainLayoutContext);
  const {
    navigateBack,
    navigateHome,
    navigateLight,
    navigateLightingGroup,
    navigateSensors,
    navigateShades,
    navigateTemperature,
  } = useAppNavigation();
  const { roomId = '' } = useParams();
  const room = useAppSelector((state) => selectRoomById(state, roomId));
  const { isLoading, data } = useGetThingsListQuery(roomId, { refetchOnMountOrArgChange: true });

  useEffect(() => {
    room?.nickName && setTitle(room?.nickName);
    showNavigationButtons(true);
    navigateBackAction(() => navigateHome);
    return () => navigateBackAction(() => navigateBack);
  }, [
    navigateBack,
    navigateBackAction,
    navigateHome,
    room?.nickName,
    setTitle,
    showNavigationButtons,
  ]);

  const onThingClick = (thing: Thing) => {
    switch (thing.identifier) {
      case ThingIdentifier.DMX:
        if (thing.thingType === ThingType.Individual) {
          navigateLight(thing.roomId, thing.id);
        } else if (thing.thingType === ThingType.GroupParent) {
          navigateLightingGroup(thing.roomId, thing.id);
        }
        break;

      case ThingIdentifier.AirQualitySensors:
        navigateSensors(thing.roomId, thing.id);
        break;

      case ThingIdentifier.Blinds:
      case ThingIdentifier.Curtains:
        navigateShades(thing.roomId, thing.id);
        break;

      case ThingIdentifier.Temperature:
        navigateTemperature(thing.roomId, thing.id);
        break;

      default:
        console.log(thing);
        break;
    }
  };

  return (
    <div
      className={twCls(
        overflow('overflow-auto'),
        margin(
          'mt-17',
          tailwindClassNameConvertNegative('-ml-2'),
          tailwindClassNameConvertNegative('-mr-2'),
        ),
        display('grid'),
        gap('gap-2'),
        justifyContent('justify-center'),
        gridAutoFlow('grid-flow-row'),
        gridAutoRows('auto-rows-min'),
        gridTemplateColumns('grid-cols-responsive-buttons'),
      )}
    >
      {isLoading && <Spinner />}
      {data &&
        data.map((thing) => (
          <RoomButton
            key={thing.id}
            iconUrl={thing.image}
            name={thing.name}
            onClick={() => onThingClick(thing)}
          />
        ))}
    </div>
  );
};
